export const hasClass = (ele, cls) => {
  return (
    ele &&
    ele.className &&
    !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"))
  );
};

export const addClass = (ele, cls) => {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
};

export const removeClass = (ele, cls) => {
  if (hasClass(ele, cls)) {
    var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
};

export const hasParentClass = (child, classname) => {
  if (
    child.className &&
    typeof child.className == "string" &&
    child.className.split(" ").indexOf(classname) >= 0
  )
    return child;
  try {
    //Throws TypeError if child doesn't have parent any more
    if (child.parentNode) return hasParentClass(child.parentNode, classname);
    return false;
  } catch (TypeError) {
    return false;
  }
};

export const on = (fromElement, eventType, selector, callback) => {
  fromElement.addEventListener(eventType, function(event) {
    if (event.target.matches(selector)) {
      callback(event.target, event);
    }
  });
};
